/**
 * ResetPasswordPage — autenticazione Phase 6 (IMPL-P6-002).
 *
 * UC-008 step 2 page. Reads `?token=` from the query string. If absent
 * (someone landed on the URL by mistake) we render an `AuthStatusPage` with
 * tone="error" + a CTA to request a new link. Otherwise we render the
 * {@link ResetPasswordForm} inside the standard auth chrome and let it own
 * the password update flow.
 */
import { useSearchParams } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { AuthLayout } from '../components/AuthLayout';
import { AuthCard } from '../components/AuthCard';
import { AuthStatusPage } from '../components/AuthStatusPage';
import { ResetPasswordForm } from '../components/ResetPasswordForm';

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  if (!token) {
    return (
      <AuthStatusPage
        icon={ShieldAlert}
        tone="error"
        title="Il link non è valido"
        description="Il link di reimpostazione password non è valido o è incompleto. Richiedi un nuovo link per procedere."
        primaryAction={{ label: 'Richiedi nuovo link', to: '/password-dimenticata' }}
        secondaryAction={{ label: 'Torna al login', to: '/accedi' }}
      />
    );
  }

  return (
    <AuthLayout>
      <AuthCard
        title="Reimposta la password"
        description="Scegli una nuova password per il tuo account. Dovrà contenere almeno 10 caratteri, una maiuscola, una minuscola e un numero."
      >
        <ResetPasswordForm token={token} />
      </AuthCard>
    </AuthLayout>
  );
}
